import { authService } from '../auth/authService';

/**
 * Fetch with Bearer token; ends local session on HTTP 401.
 */
export async function authenticatedFetch(url, options = {}, scopeType = 'qgisApi') {
  const headers = { ...options.headers };

  if (!headers.Authorization) {
    const token = await authService.getAccessToken(scopeType);
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    await authService.endLocalSession('api_401', { throwError: true });
  }

  return response;
}
